(function () {
  'use strict';

  const SRCSET_WIDTHS = [493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];
  const SIZES_ATTR = '(min-width: 1300px) 660px, (min-width: 990px) calc(55.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

  function buildSrcset(image) {
    const base = image.src_base || image.src_1946;
    const baseUrl = base.split('?')[0];
    const versionMatch = base.match(/[?&]v=([^&]+)/);
    const version = versionMatch ? versionMatch[1] : '';
    const parts = [];
    SRCSET_WIDTHS.forEach((w) => {
      if (image.width >= w) {
        const url = `${baseUrl}?${version ? 'v=' + version + '&' : ''}width=${w}`;
        parts.push(`${url} ${w}w`);
      }
    });
    parts.push(`${base} ${image.width}w`);
    return parts.join(', ');
  }

  function escapeAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function htmlToElement(html) {
    const tpl = document.createElement('template');
    tpl.innerHTML = html.trim();
    return tpl.content.firstElementChild;
  }

  function buildMainSlide(image, index, mediaId, enableZoom, productHandle) {
    const aspectRatio = image.aspect_ratio || 1;
    const height = Math.ceil(1000 / aspectRatio);
    const srcset = buildSrcset(image);
    const alt = escapeAttr(image.alt || '');
    const lazyAttrs = index !== 0 ? 'loading="lazy" fetchpriority="low"' : '';
    const zoomHtml = enableZoom
      ? `<div class="zoom-in transition-all opacity-0 absolute z-10 right-5 top-5">
          <button class="sf__tooltip-item sf__btn-icon sf-prod-media__zoom-in sf__tooltip-left sf__tooltip-style-1" type="button" data-product-handle="${escapeAttr(productHandle)}">
            <span class="sf__tooltip-icon block">
              <svg class="w-[20px] h-[20px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" stroke="currentColor"><path d="M319.8 204v8c0 6.6-5.4 12-12 12h-84v84c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-84h-84c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h84v-84c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12zm188.5 293L497 508.3c-4.7 4.7-12.3 4.7-17 0l-129-129c-2.3-2.3-3.5-5.3-3.5-8.5v-8.5C310.6 395.7 261.7 416 208 416 93.8 416 1.5 324.9 0 210.7-1.5 93.7 93.7-1.5 210.7 0 324.9 1.5 416 93.8 416 208c0 53.7-20.3 102.6-53.7 139.5h8.5c3.2 0 6.2 1.3 8.5 3.5l129 129c4.7 4.7 4.7 12.3 0 17zM384 208c0-97.3-78.7-176-176-176S32 110.7 32 208s78.7 176 176 176 176-78.7 176-176z"></path></svg>
            </span>
            <span class="sf__tooltip-content" data-revert-text="">Ampliar</span>
          </button>
        </div>`
      : '';

    const html = `
      <div
        class="swiper-slide sf-prod-media-item relative overflow-hidden media-type-image"
        data-index="${index}"
        data-media-type="image"
        data-media-id="${escapeAttr(mediaId)}"
        data-aspect-ratio="${aspectRatio}"
        data-variant-gallery-item="true"
      >
        <div
          class="sf-prod-media media-image"
          data-media-id="${escapeAttr(mediaId)}"
          data-media-width="${image.width}"
          data-media-height="${image.height}"
          data-media-alt="${alt}"
          data-media-src="${escapeAttr(image.src_1946)}"
        >
          <responsive-image class="sf-image" data-image-loading style="--aspect-ratio: ${aspectRatio}">
            <img
              srcset="${escapeAttr(srcset)}"
              src="${escapeAttr(image.src_1946)}"
              sizes="${escapeAttr(SIZES_ATTR)}"
              ${lazyAttrs}
              width="1000"
              height="${height}"
              alt="${alt}"
            >
          </responsive-image>
        </div>
        ${zoomHtml}
      </div>
    `;
    return htmlToElement(html);
  }

  function buildNavSlide(image, index, mediaId, layout) {
    const aspectRatio = image.aspect_ratio || 1;
    const navHeight = Math.ceil(110 / aspectRatio);
    const alt = escapeAttr(image.alt || '');
    const styleAttr = layout === 'layout-6'
      ? `style="--slide-height: ${70 / aspectRatio}px;"`
      : '';

    const html = `
      <div
        class="swiper-slide relative cursor-pointer media-type-image"
        data-index="${index}"
        data-variant-gallery-item="true"
        ${styleAttr}
      >
        <div
          class="sf-prod-media media-image"
          data-media-id="${escapeAttr(mediaId)}"
          data-media-width="${image.width}"
          data-media-height="${image.height}"
          data-media-alt="${alt}"
          data-media-src="${escapeAttr(image.src_1946)}"
        >
          <responsive-image class="sf-image" data-image-loading style="--aspect-ratio: ${aspectRatio}">
            <img
              src="${escapeAttr(image.src_110)}"
              loading="lazy"
              width="110"
              height="${navHeight}"
              alt="${alt}"
            >
          </responsive-image>
        </div>
      </div>
    `;
    return htmlToElement(html);
  }

  function swapGallery(gallery, images, productHandle) {
    if (!gallery || !images || images.length === 0) {
      console.warn('[variant-gallery] swap skipped', { hasGallery: !!gallery, imageCount: images && images.length });
      return;
    }

    const isVisible = window.getComputedStyle(gallery).display !== 'none';
    const enableZoom = gallery.dataset.enableImageZoom === 'true';
    const layout = gallery.dataset.layout;

    const mainSlides = images.map((img, i) => buildMainSlide(img, i, `vg-${i}`, enableZoom, productHandle));
    const navSlides = images.map((img, i) => buildNavSlide(img, i, `vg-${i}`, layout));

    const usedSwiperMain = !!(gallery.slider && typeof gallery.slider.removeAllSlides === 'function');
    if (usedSwiperMain) {
      try {
        gallery.slider.removeAllSlides();
        gallery.slider.appendSlide(mainSlides);
        if (typeof gallery.slider.update === 'function') gallery.slider.update();
        if (typeof gallery.slider.slideToLoop === 'function') {
          gallery.slider.slideToLoop(0, 0);
        } else if (typeof gallery.slider.slideTo === 'function') {
          gallery.slider.slideTo(0, 0);
        }
      } catch (e) {
        console.error('[variant-gallery] swiper main swap failed', e);
      }
    } else {
      const mainWrapper = gallery.querySelector('.swiper-wrapper.main-slider');
      if (mainWrapper) {
        mainWrapper.innerHTML = '';
        mainSlides.forEach((s) => mainWrapper.appendChild(s));
      }
    }

    const usedSwiperNav = !!(gallery.navSlider && typeof gallery.navSlider.removeAllSlides === 'function');
    if (usedSwiperNav) {
      try {
        gallery.navSlider.removeAllSlides();
        gallery.navSlider.appendSlide(navSlides);
        if (typeof gallery.navSlider.update === 'function') gallery.navSlider.update();
        if (typeof gallery.navSlider.slideToLoop === 'function') {
          gallery.navSlider.slideToLoop(0, 0);
        } else if (typeof gallery.navSlider.slideTo === 'function') {
          gallery.navSlider.slideTo(0, 0);
        }
      } catch (e) {
        console.error('[variant-gallery] swiper nav swap failed', e);
      }
    } else {
      const navWrapper = gallery.querySelector('.nav-swiper-container .swiper-wrapper');
      if (navWrapper) {
        navWrapper.innerHTML = '';
        navSlides.forEach((s) => navWrapper.appendChild(s));
      }
    }

    if (typeof gallery.handleSlideChange === 'function') {
      try { gallery.handleSlideChange(); } catch (e) {}
    }

    console.log('[variant-gallery] swapped', {
      gallery: gallery.dataset.screen || 'desktop',
      visible: isVisible,
      newSlideCount: mainSlides.length,
      usedSwiper: usedSwiperMain,
    });
  }

  function init() {
    const dataScript = document.querySelector('[data-variant-gallery-data]');
    if (!dataScript) {
      console.warn('[variant-gallery] data script not found');
      return;
    }

    let galleryData;
    try {
      galleryData = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('[variant-gallery] failed to parse data', e);
      return;
    }

    const productId = dataScript.dataset.productId;
    if (!productId) {
      console.warn('[variant-gallery] no productId on data script');
      return;
    }

    const galleries = document.querySelectorAll(`media-gallery[data-product-id="${productId}"][data-variant-gallery="true"]`);
    if (!galleries.length) {
      console.warn('[variant-gallery] no media-gallery found for', productId);
      return;
    }

    const productHandle = galleries[0].dataset.productHandle || '';
    const variantKeys = Object.keys(galleryData);

    console.log('[variant-gallery] init', { productId, galleries: galleries.length, variantsInData: variantKeys.length });

    const handler = (variant) => {
      if (!variant || !variant.id) {
        console.warn('[variant-gallery] handler called without variant');
        return;
      }
      const images = galleryData[variant.id] || galleryData[String(variant.id)];
      console.log('[variant-gallery] variant change', { variantId: variant.id, found: !!images, count: images && images.length });
      if (!images || images.length === 0) return;
      galleries.forEach((gallery) => swapGallery(gallery, images, productHandle));
    };

    const eventName = `${productId}__VARIANT_CHANGE`;

    function attachListener() {
      if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
        window.MinimogEvents.subscribe(eventName, handler);
        console.log('[variant-gallery] subscribed to', eventName);
        return true;
      }
      return false;
    }

    if (!attachListener()) {
      let attempts = 0;
      const interval = setInterval(() => {
        attempts += 1;
        if (attachListener() || attempts > 50) {
          clearInterval(interval);
          if (attempts > 50) console.error('[variant-gallery] MinimogEvents never became available');
        }
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
